export default __webpack_public_path__ + "static/media/me5.94045210.jpg";